var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPhoneicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.616 14.2371L15.8298 11.4507C15.2749 10.898 14.3559 10.9148 13.7816 11.4893L12.378 12.8926C12.2893 12.8437 12.1975 12.7927 12.101 12.7385C11.2146 12.2474 10.0014 11.5742 8.72479 10.2967C7.44438 9.01641 6.77059 7.80136 6.27795 6.91439C6.22596 6.82043 6.17615 6.72983 6.12697 6.64379L7.06903 5.70313L7.53218 5.23941C8.10734 4.66409 8.1232 3.74536 7.56955 3.19103L4.78343 0.404295C4.22978 -0.149249 3.31037 -0.132456 2.73522 0.442856L1.94999 1.23259L1.97145 1.25389C1.70815 1.58985 1.48814 1.97733 1.3244 2.39519C1.17348 2.79293 1.07951 3.17248 1.03654 3.55281C0.668653 6.60269 2.06236 9.39005 5.8447 13.1724C11.073 18.4004 15.2864 18.0055 15.4682 17.9862C15.864 17.9389 16.2434 17.8443 16.629 17.6946C17.0432 17.5327 17.4305 17.313 17.7662 17.0503L17.7834 17.0655L18.5788 16.2866C19.1528 15.7114 19.1693 14.7923 18.616 14.2371Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhoneicon);
export default __webpack_public_path__ + "static/media/ic_phone.icon.1febd79c22dc28ddc7d4ad7de587b062.svg";
export { ForwardRef as ReactComponent };